const hex = (x) => x.toString(16).length === 1 ? "0" + x.toString(16) : x.toString(16), shortToLongHex = (hex2) => {
  const r = hex2.substring(1, 2), g = hex2.substring(2, 3), b = hex2.substring(3);
  return `#${r}${r}${g}${g}${b}${b}`;
}, getR = (c) => parseInt(c.substring(1, 3), 16), getG = (c) => parseInt(c.substring(3, 5), 16), getB = (c) => parseInt(c.substring(5), 16), getRGB = (hex2) => (hex2.length === 4 && (hex2 = shortToLongHex(hex2)), `rgb(${getR(hex2)}, ${getG(hex2)}, ${getB(hex2)})`), getRGBA = (hex2, opacity) => (hex2.length === 4 && (hex2 = shortToLongHex(hex2)), `rgba(${getR(hex2)}, ${getG(hex2)}, ${getB(hex2)}, ${opacity})`);
export {
  getB,
  getG,
  getR,
  getRGB,
  getRGBA,
  hex,
  shortToLongHex
};
